<template>
  <div class="main">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>微信管理</el-breadcrumb-item>
      <el-breadcrumb-item>微商城</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tab">
        <div @click="tabClikc(item.value)" :class="item.value==aindex?'active':''" v-for="(item,index) in tab" :key="index">{{ item.label }}</div>
    </div>
    <div class="center_table" v-if="aindex==1">
        <div class="top">
          <div class="input_div">
            <el-input v-model="data.ProductName" placeholder="产品名称"></el-input>
            <el-select v-model="data.ProductType" placeholder="商品类型" clearable>
              <el-option
                v-for="item in typeArr"
                :key="item.typeid"
                :label="item.typename"
                :value="item.typeid"
              ></el-option>
            </el-select>
            <el-select v-model="data.UseFlag" placeholder="产品状态" clearable>
              <el-option
                v-for="item in option"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="btns" @click="btns">
               查询
            </div>
          </div>
          <div class="right_btn">
              <div @click="add">添加商品</div>
              <!-- <div>删除</div> -->
          </div>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
        >
          <!-- <el-table-column   label="排序" width="100">
            <template slot-scope="scope">
              <div class="paixu">
                <el-input v-model="scope.row.id" @blur="sortBlur(scope.row)" ></el-input>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="ProductName" label="产品名称" width="200"></el-table-column>
          <el-table-column  label="每日购买限制">
            <template  slot-scope="scope">
              <span>{{ scope.row.NumBerflag=='0'?'无限制':scope.row.NumBerflag }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="daynum" label="每日已售"></el-table-column>
          <!-- <el-table-column  label="总购买限制">
            <template  slot-scope="scope">
              <span>{{ scope.row.dayflag=='0'?'无限制':scope.row.dayflag }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="daynum" label="总已售"></el-table-column>
          <el-table-column prop="ReturnFlag" label="是否可退">
            <template  slot-scope="scope">
              <div v-if="scope.row.ReturnFlag=='0'">
                <img src="@/images/scenic/dhl.png" alt />
              </div>
              <div  v-if="scope.row.ReturnFlag=='1'">
                <img src="@/images/scenic/xhh.png" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ReturnFlag" label="首页是否显示">
            <template  slot-scope="scope">
              <el-switch
                v-model="scope.row.product_push=='1'?true:false"
                @change='Status(scope.row,$event)'
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="微商城操作" width="200"    fixed="right">
            <template slot-scope="scope">
              <span class="tab_del" @click="deteleBnts(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
        </div>
    </div>
    <div class="center_table" v-if="aindex==2">
        <div class="top">
          <div class="input_div">
            <el-input v-model="data1.ordernumber" placeholder="订单号"></el-input>
            <el-select v-model="data1.shStatus" placeholder="全部状态" clearable>
              <el-option
                v-for="item in option1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <div class="btns" @click="btns1">
               查询
            </div>
          </div>
          <div class="right_btn">
              <!-- <div>删除</div> -->
          </div>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          
          <el-table-column prop="nickname" label="昵称" width="200"></el-table-column>
          <el-table-column prop="ordernumber" label="订单号"></el-table-column>
          <el-table-column prop="createtime" label="评论时间"></el-table-column>
          <el-table-column  label="评论内容" prop="content">
          </el-table-column>
          <el-table-column  label="状态">
            <template  slot-scope="scope">
              <span :class="scope.row.shenhestatus=='1'?'destates':scope.row.shenhestatus=='2'?'states':'destates'" >{{ scope.row.shenhestatus
=='1'?'未审核':scope.row.shenhestatus
=='2'?'审核通过':scope.row.shenhestatus
=='3'?'未通过':'' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" width="200"    fixed="right">
            <template slot-scope="scope">
              <span class="tab_detail" @click="viewClick(scope.row)" >查看</span>
              <span class="tab_det" @click="viewdete(scope.row)" >删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data1.limit" :total="total" :current-page="data1.page"  @current-change="currenchange1" ></el-pagination>
        </div>
    </div>
    <div class="center_table" v-if="aindex==3">
      <div class="top">
          <div class="input_div">
            <el-input v-model="data2.title" placeholder="活动名称" style="width:35rem;"></el-input>
            <div class="btns" @click="btns3">
               查询
            </div>
          </div>
          <div class="right_btn">
              <div @click="addActivy">添加活动</div>
              <!-- <div >排序</div> -->
              <div @click="deteleClick">删除</div>
          </div>
      </div>
      <el-table
          ref="multipleTable"
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="table2"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="nickname" label="排序" width="100">
              <template  slot-scope="scope">
                  <el-input @change="sortChage(scope.row)" v-model="scope.row.sort"></el-input>
              </template>
          </el-table-column>
          <el-table-column prop="title" label="活动名称" ></el-table-column>
          <el-table-column prop="activity_cost" label="活动费用"></el-table-column>
          <el-table-column  label="活动时间" prop="starttime"></el-table-column>
          <el-table-column  prop="endtime" label="报名截止时间" ></el-table-column>
          <el-table-column  label="总购买限制" >
            <template slot-scope="scope">
                {{scope.row.buy_limit=='1'?'无限制':scope.row.buy_limit}}
            </template>
          </el-table-column>

          <el-table-column prop="join_num"  label="报名人数" ></el-table-column>
          <el-table-column  label="是否可退" >
              <template slot-scope="scope">
                  <img src="@/assets/dhl.png" alt="" v-if="scope.row.returnflag=='1'">
                  <img src="@/assets/xhh.png" alt="" v-if="scope.row.returnflag=='2'"> 
              </template>
          </el-table-column>
          <el-table-column  label="状态">
            <template  slot-scope="scope">
                <span class="tab_detail" @click="modify(scope.row)">{{scope.row.state=='1'?'上架 ':'下架'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <span class="tab_detail" style="margin-right:2rem;"  @click="checkData(scope.row)">数据</span>
              <span class="tab_detail" style="margin-right:2rem;"  @click="edit(scope.row)">编辑</span>
              <!-- <span class="tab_del"   @click="deteleClick(scope.row)">删除</span> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="totla">排序规则遵循降序规则，数据按照从大到小的顺序排列，数据越大内容越往前，新填加的内容系统默认排序为0</span>
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data2.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data2.limit" :total="total" :current-page="data2.page"  @current-change="currenchange2" ></el-pagination>
        </div>
    </div>
    <div class="center_table" v-if="aindex==4">
      <campCourse ref="campCourse" />
    </div>
    <addmall ref="addDialog" v-if="addFlow" @close="SetClose"></addmall>
    <Views ref="ViewDialog" v-if="addView" @close="VClose"></views>
    <signData ref="signDialog" v-if="signFlow" @close="signClose"></signData>
    <addactivity ref="actiDialog" :title='title' v-if="actiFlow" @close="activeClose"></addactivity>
    <edit  ref="editDialog"  v-if="editflow" @close="editClose"></edit>
  </div>
</template>
<script>
  import addmall from './dialog/addMall.vue'
  import { WshopList,ScenicProductType,WshopDetele,evaluateList} from '@/request/scenic.js'
  import {MessageBox,Message} from 'element-ui'
  import Views from './dialog/views.vue'
  import signData from './dialog/signData.vue'
  // addactivity.vue
  import addactivity from './dialog/addactivity.vue'
  import edit from './dialog/edit.vue'
  import campCourse from './campCourse.vue'

  export default{
    data(){
      return{
        editflow:false,
        title:'添加活动',
        actiFlow:false,
        signFlow:false,
        addView:false,
        aindex:1,
        tab:[
          {
            value:'1',
            label:'商品管理'
          },
          {
            value:'2',
            label:'评论管理'
          },
          {
            value:'3',
            label:'活动管理'
          },
          {
            value:'4',
            label:'营地课程'
          }
        ],
        option:[
          {
            value:'0',
            label:'上线'
          },
          {
            value:'1',
            label:'下线'
          }
        ],
        tableData:[
        ],
        addFlow:false,
        data:{
          page:1,
          page_size:10,
          token:window.sessionStorage.getItem('Token'),
          ProductType:'',
          UseFlag:'',
          ProductName:''
        },
        total:0,
        typeArr:[],
        loading:true,
        data1:{
          scenicid:window.sessionStorage.getItem('ScenicId'),
          ordernumber:'',
          shStatus:'',
          limit:10,
          page:1,
          token:window.sessionStorage.getItem('Token')
        },
        option1:[
          {
            value:'0',
            label:'显示全部'
          },
          {
            value:'1',
            label:'未审核'
          },
          {
            value:'2',
            label:'审核通过'
          },
          {
            value:'3',
            label:'未通过'
          }
        ],
        data2:{
          scenicid:window.sessionStorage.getItem('ScenicId'),
          title:'',
          limit:10,
          page:1
        },
        minut:[]
      }
    },
    components:{
      addmall,
      Views,
      signData,
      addactivity,
      edit,
      campCourse
    },
    created(){
      // let data = {
      //   token:window.sessionStorage.getItem('Token'),
      // }
      // ScenicMessage(data).then(res=>{
      //   if(res.data.status=='ok'){

      //    window.sessionStorage.setItem('ScenicId',res.data.result.scenic_id)
      //   }
      // })
      this.applyRouteTab()
      this.getList()
      this.getType()
    },
    watch: {
      '$route.query.tab'() {
        this.applyRouteTab()
      }
    },
    methods:{
      applyRouteTab() {
        if (String(this.$route.query.tab) === '4') {
          this.aindex = '4'
        }
      },
      sortChage(item){
        if(item.sort<0){
          this.$message.error('请输入大于0的整数')
          return false
        }else{
          let num = /^[0-9]*$/.test(item.sort)
          if(num){
          }else{
            this.$message.error('请输入整数')
            return false
          }
        }
        let data = {
          id:item.id,
          sort:item.sort
        }
        this.MethodPost(
            "http://jhyapi.softykt.cn/member/activity/sortChange",
            data
          ).then((res) => {
            if(res.data.code==666){
                this.$message.success('操作成功')
                this.getList2()
            }
        })
        
      },
      // 多选
      handleSelectionChange(val) {
        this.minut = val
      },
      deteleClick(){
        if(this.minut.length==0){
          this.$message.error('请选择删除数据')
          return false
        }
        MessageBox('此操作删除该活动, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          let id = ''
          this.minut.map(items=>{
              id += items.id + ','
          })
          let state = 3
          let data = {
            id:id.slice(0, -1),
            state:state
          }
          this.MethodPost(
            "http://jhyapi.softykt.cn/member/activity/changeActivity",
            data
          ).then((res) => {
            if(res.data.code==666){
              this.$message.success('删除成功')
              this.data2.page = 1
              this.getList2()
            }
          })
        })
      },
      modify(row){
        MessageBox('此操作修改活动状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          let state = row.state=='1'?'2':'1'
          let data = {
            id:row.id,
            state:state
          }
          this.MethodPost(
            "http://jhyapi.softykt.cn/member/activity/changeActivity",
            data
          ).then((res) => {
            if(res.data.code==666){
              this.$message.success('修改成功')
              this.tableData = []
              this.getList2()
            }
          })
        })
      },
      currenchange2(e){
        this.data2.page =e
        this.getList2()
      },
      btns3(){
        this.data2.page = 1
        this.getList2()
      },
      // 活动列表
      getList2(){
        this.MethodPost(
          "http://jhyapi.softykt.cn/member/activity/activityList",
          this.data2
        ).then((res) => {
          if(res.data.code=='666'){
            this.total = res.data.count
            this.tableData = res.data.list
          }
        })
      },
      // 关闭
      editClose(){
        this.getList2()
        this.editflow = false
      },
      // 打开
      edit(row){
        let ro = ''
        if(row){
          ro = row
        }else{
          ro = ''
        }
        this.actiFlow = true
        this.$nextTick(() => {
          this.$refs.actiDialog.pxFn(ro);
        });
      },
      // 关闭添加活动
      activeClose(res){
        this.actiFlow = false
        this.editflow = true
        this.$nextTick(() => {
          this.$refs.editDialog.pxFn(res.actid);
        });
      },
      // 添加活动.活动详情
      addActivy(){
          this.actiFlow = true
          this.$nextTick(() => {
            this.$refs.actiDialog.pxFn();
          });
      },
      signClose(){
        this.signFlow = false
      },
      // 活动数据
      checkData(row){
        this.signFlow = true
        this.$nextTick(() => {
          this.$refs.signDialog.pxFn(row);
        });
      },
      viewdete(row){
        MessageBox('此操作删除该评论, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            id:row.id,
            token:window.sessionStorage.getItem('Token')
          }
          this.MethodPost(
            "http://jhyapi.softykt.cn/member/member/evaluateDelete",
            data
          ).then((res) => {
            if(res.data.code=='666'){
              Message.success('删除成功')
              this.getList1()
            }else{
              Message.error(res.data.msg)
            }
          })
        }).catch(() => {
          this.getList2()
                 
        });
      
      },
      VClose(){
        this.data1.page
        this.addView = false
        this.getList1()
      },
      viewClick(row){
        this.addView = true
        this.$nextTick(() => {
          this.$refs.ViewDialog.pxFn(row);
        });
      },
      btns1(){
        this.data1.page = 1
        this.getList1()
      },
      currenchange1(e){
        this.data1.page = e
        this.getList1()
      },
      getList1(){
        this.MethodPost(
          "http://jhyapi.softykt.cn/member/member/evaluateList",
          this.data1
        ).then((res) => {
          if(res.data.code=='666'){
            this.total = res.data.count
            this.tableData = res.data.list
          }
        })
      },
      Status(row,e){
        let num = ''
        if(e){
          num = 1
        }else{
          num = 0
        }
        this.$forceUpdate()
        let data = {
            token:window.sessionStorage.getItem('Token'),
            ProductID:row.ProductID,
            product_push:num
          }
          WshopDetele(data).then(res=>{
            if(res.data.status=='ok'){
              this.getList()
              Message.success('操作成功')
            }else{
              Message.error(res.data.msg)
            }
          })
      },
      tabClikc(e){
        if(this.loading == true && e != 4 && e != '4'){
          return false
        }
        this.tableData = []
        this.aindex = e
        if(e=='1' || e==1){
          this.loading = true
          this.getList()
        }else if(e==2 || e=='2'){
          this.getList1()
        }else if(e==3 || e=='3'){
          this.getList2()
        }
      },
      // 删除
      deteleBnts(row){
        MessageBox('此操作删除该产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let num = ''
          if(row.shopstate){
            num = 1
          }else{
            num = 0
          }
          let data = {
              token:window.sessionStorage.getItem('Token'),
              ProductID:row.ProductID,
              type:2,
              product_push:num
            }
            WshopDetele(data).then(res=>{
              if(res.data.status=='ok'){
                this.getList()
                Message.success('删除成功')
              }else{
                Message.error(res.data.msg)
              }
            })
        }).catch(() => {
                 
        });
      },
      getType(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
        }
        ScenicProductType(data).then(res=>{
          if(res.data.status=='ok'){
            this.typeArr=res.data.result
          }
        })
      },
      currenchange(e){
        this.data.page = e
        this.loading = true
        this.getList()
      },
      btns(){
        this.data.page=1
        this.total = 0
        this.loading = true
        this.getList()
      },
      getList(){
        WshopList(this.data).then(res=>{
          if(res.data.status=='ok'){
            this.tableData = res.data.result.data
            this.total = res.data.result.total
            this.loading = false
          }
        })
      },
      // 添加商品
      add(){
        this.addFlow = true
        this.$nextTick(() => {
          this.$refs.addDialog.pxFn();
        });
      },
      // 关闭商品
      SetClose(){
        this.getList()
        this.addFlow = false
      },
      // 表头设置
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return this.utils.tableHeaderColor({
          row,
          column,
          rowIndex,
          columnIndex
        });
      },
      cellStyle({ row, rowIndex }) {
        return this.utils.cellStyle({
          row,
          rowIndex
        });
      }
    }
  }
</script>
<style scoped lang="less">
  .tab{
    margin-top: 1.8rem;
    display: flex;
    align-items: center;
    >div{
      margin-right: 2rem;
      width: 11rem;
      height: 4rem;
      border-radius: 4px;
      color: #fff;
      font-size: 1.4rem;
      text-align: center;
      line-height: 4rem;
      cursor: pointer;
      background: #D9D9D9;
    }
    .active{
      background: #246DEB;
    }
  }
  .center_table{
    margin-top: 2rem;
    background: #fff;
    padding: 2rem;
    box-sizing: border-box;
    .top{
      display: flex;
      justify-content: space-between;
      margin-bottom: 2rem;
    }
    .right_btn{
      display: flex;
      align-items: center;
      >div{
        width: 11rem;
        height: 4rem;
        border-radius: 4px;
        font-size: 1.4rem;
        text-align: center;
        line-height: 4rem;
        cursor: pointer;
        border-radius: 4px;
        margin-left: 2rem;
        &:nth-child(1){
          border: 1px solid #246DEB;
          color: #246DEB;
        }
        // &:nth-child(2){
        //   border: 1px solid #246DEB;
        //   color: #246DEB;
        // }
        &:nth-child(2){
          border: 1px solid #E74C3C;
          color: #E74C3C;
        }
      }
    }
    .input_div{
      display: flex;
      align-items: center;
      .el-input{
        width: 22rem;
        margin-right: 2rem;
      }
      .el-select{
        width: 22rem;
        margin-right: 2rem;
      }
      .btns{
        width: 11rem;
        height: 4rem;
        border-radius: 4px;
        background: #246DEB;
        color: #fff;
        font-size: 1.4rem;
        text-align: center;
        line-height: 4rem;
        cursor: pointer;
      }
    }
  }
  .tab_del{
    color: #E74C3C;
    font-size: 1.4rem;
    cursor: pointer;
  }
  .paixu{
    ::v-deep .el-input{
      width: 6rem;
    }
    ::v-deep .el-input input{
      border-radius: 4px;
      background: #F7F7FA;
      color: #000;
      width: 6rem;
      text-align: center;
      padding: 0 3px;
    }
  }
  // 分页
.pagination {
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.totla{
  position: absolute;
  left: 2rem;
  width: 35rem;
  color: red !important;
}
.tab_detail{
  cursor: pointer;
  color: #246DEB;
}
.states{
  color: #4ECB73;
}
.destates{
  color: #E43535;
}

.tab_det{
  color: #E43535;
  margin-left: 1rem;
  cursor: pointer;
}
</style>